import { render } from "./KerjaSama.vue?vue&type=template&id=5833a34b"
import script from "./KerjaSama.vue?vue&type=script&lang=js"
export * from "./KerjaSama.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__